import classNames from 'classnames'
import { Icon } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type Tag } from 'entities/Tags/model/Tag'

import styles from './styles.module.scss'

interface ITagCounterElementProps {
  variant: 'counter'
  count: number
  className?: string
}

interface ITagDefaultElementProps {
  tag: Tag
  variant: 'default'
  className?: string
  closable?: boolean
  onRemove?: (tag: Tag) => void
}

type TagElementProps = ITagCounterElementProps | ITagDefaultElementProps

export const TagElement = (props: TagElementProps) => {
  const { variant, className } = props

  if (variant === 'counter') {
    return (
      <div
        className={classNames(styles.tagWrapper, className)}
        aria-label={getAriaLabel('RestCount_tagsListItem')}
      >
        +{props.count}
      </div>
    )
  }

  const { closable, tag, onRemove } = props

  return (
    <div
      className={classNames(styles.tagWrapper, className)}
      aria-label={getAriaLabel('Added_tagsListItem')}
    >
      <span className={styles.tagLabel}>{tag.label}</span>
      {!!closable && (
        <div
          className={styles.icon}
          onClick={() => onRemove?.(tag)}
          aria-label={getAriaLabel('Remove', 'Added_tagsListItem')}
        >
          <Icon icon='close' />
        </div>
      )}
    </div>
  )
}
